/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class WarningApi {
    static getInstance() {
        if (!this.instance) this.instance = new WarningApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取预警列表
    async getWarningList (param, page_num, page_size){
        let url = `/api/warning/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 变更状态
    async changeToError (param, id){
        let url = `/api/warning/update/error/${id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取仓库下拉
    async getWarehouse(){
        let url = `/api/order/warehouse`
        let result = await this.getData(url,{},'GET')
        return result
    }
}

export {
    WarningApi
}